export enum orgFields {
  "OPT-300-Procedure-Buyer",
  "OPT-300-Procedure-SProvider",
  "OPT-301-Lot-FiscalLegis",
  "OPT-301-Lot-EnvironLegis",
  "OPT-301-Lot-EmployLegis",
  "OPT-301-Lot-AddInfo",
  "OPT-301-Lot-DocProvider",
  "OPT-301-Lot-ReviewOrg",
  "OPT-301-Lot-ReviewInfo",
  "OPT-301-Lot-Mediator",
  "OPT-300-Tenderer",
  "OPT-301-Tenderer-SubCont",
  "OPT-301-Tenderer-MainCont",
  "OPT-300-Contract-Signatory",
  "OPT-301-LotResult-Financing",
  "OPT-301-LotResult-Paying"
}